import styled from 'styled-components'

const CardsEffectSliderGalleryStyle = styled.div`
    --cesgTitleMarginBottom: var(--sp9x);
    --cesgDescriptionMarginTop: var(--sp11x);
    --cesgFullFileProportion: 50.5%;

    text-align: center;
    overflow: hidden;

    .cesg-title {
        margin-bottom: var(--cesgTitleMarginBottom);
    }

    .cesg-description {
        margin-top: var(--cesgDescriptionMarginTop);
    }

    .ces-module {
        margin: 0 calc(var(--contPaddingH) * -1);
    }

    .cesg-full-image-container {
        .imageCont {
            --fullWidthImagePaddingTop: var(--cesgFullFileProportion);
        }
    }

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
        --cesgTitleMarginBottom: var(--sp7x);
        --cesgDescriptionMarginTop: var(--sp9x);
    }

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
        --cesgTitleMarginBottom: var(--sp6x);
        --cesgDescriptionMarginTop: var(--sp8x);
    }

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
        --cesgTitleMarginBottom: var(--sp6x);
        --cesgDescriptionMarginTop: var(--sp8x);
    }

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
        --cesgTitleMarginBottom: var(--sp5x);
        --cesgDescriptionMarginTop: var(--sp5x);
        --cesgFullFileProportion: 50.46%;
    }

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
        --cesgTitleMarginBottom: var(--sp4x);
        --cesgDescriptionMarginTop: var(--sp5x);
        --cesgFullFileProportion: 50.39%;
    }

    @media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
        --cesgTitleMarginBottom: var(--sp5x);
        --cesgDescriptionMarginTop: var(--sp5x);
        --cesgFullFileProportion: 67.18%;
    }

    @media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
        --cesgTitleMarginBottom: var(--sp5x);
        --cesgDescriptionMarginTop: var(--sp5x);
        --cesgFullFileProportion: 71.98%;
    }
`

export default CardsEffectSliderGalleryStyle